import React, { Component } from "react";
import LiquidFillGauge from "../TaskLiquidFill";
import Loading from "../../Loading";
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";

// Material-UI
import { Paper, Dialog, FlatButton, FloatingActionButton } from "material-ui";

export default class CompanyView extends Component {
  constructor(props) {
    super(props);

    this.state = {
      styles: {
        center: {
          textAlign: "center",
        },
        paper: {
          width: "96%",
          margin: 30,
        },
        floatingButton: {
          marginLeft: 25,
        },
        paperDiv: {
          width: "47%",
          margin: 20,
          display: "inline-block",
        },
        textButton: {
          background: "none",
          border: "none",
          margin: 0,
          padding: 0,
          cursor: "pointer",
          color: "blue",
        },
      },
    };

    this.linkFormatter = this.linkFormatter.bind(this);
  }

  static componentData = {
    needs: "Company",
    multiple: false,
    withRelated: [
      "projects",
      "projects.tasks",
      "projects.timeEntries",
      "completeTasks",
      "unCompleteTasks",
    ],
  };

  componentWillMount() {
    this.props.authFetchDetails(
      "teamwork/companies/" + this.props.params._id,
      this.props.token.jwt,
    );
  }

  linkFormatter(cell, row) {
    return (
      <button
        style={this.state.styles.textButton}
        onClick={this.props.performRoute.bind(
          this,
          `/job/teamwork/projects/${row.id}-${row.tid}`,
        )}
      >
        {cell}
      </button>
    );
  }

  render() {
    let { name, projects } = this.props.details;
    let { center, paper, paperDiv } = this.state.styles;
    let filter = { type: "TextFilter", delay: 500 };

    if (this.props.isLoading) {
      return (
        <div className="container">
          <center>
            <Loading color={this.props.appbar.color} />
          </center>
        </div>
      );
    } else if (this.props.details.projects) {
      let totalTasks =
        this.props.details.completeTasks.length +
        this.props.details.unCompleteTasks.length;
      let percentComplete =
        (this.props.details.completeTasks.length / totalTasks) * 100;
      return (
        <Paper
          className="container"
          zDepth={2}
          style={{ marginTop: "2em", paddingTop: "1em" }}
        >
          <center>
            <h1>{name}</h1>
            <br />
          </center>
          <div style={{ zoom: "50%" }}>
            <LiquidFillGauge
              color={this.props.appbar.color}
              percentComplete={percentComplete}
            />
          </div>
          <center>
            <br />
            <h3>Projects</h3>
          </center>
          <BootstrapTable data={projects} pagination>
            <TableHeaderColumn
              dataField="name"
              filter={filter}
              dataSort
              isKey
              dataFormat={this.linkFormatter}
            >
              Name
            </TableHeaderColumn>
            <TableHeaderColumn dataField="description" dataSort filter={filter}>
              Description
            </TableHeaderColumn>
            <TableHeaderColumn
              dataField="timeEstimate"
              dataSort
              filter={filter}
            >
              Estimated Minutes
            </TableHeaderColumn>
            <TableHeaderColumn dataField="hours" dataSort filter={filter}>
              Entered Hours
            </TableHeaderColumn>
            <TableHeaderColumn dataField="mins" dataSort filter={filter}>
              Entered Minutes
            </TableHeaderColumn>
          </BootstrapTable>
        </Paper>
      );
    } else {
      return null;
    }
  }
}



// WEBPACK FOOTER //
// ./app/components/teamwork/companies/CompanyView.js